import { createIdentifier } from '@wendellhu/redi';
import type { EngrEngineeringDTO, EngrVersionDTO } from '@holoview/dao-gen/generated';
import type {
  ActiveSolutionCardsQueryParams,
  CompletedTaskDispatchCountQueryParams,
  SolutionAppendsQueryParams,
  SolutionCreatePayload,
  SolutionImagingParseStateDto,
  SolutionPlanSetupUpdatePayload,
  SolutionWithCase,
} from '../dto/solution.dto';

export interface ISolutionRepository {
  getCaseMeta(solutionId: number): Promise<SolutionWithCase | null>;
  getMdpsProductionOrderId(params: { solutionId: number; caseId?: number | null }): Promise<number | null>;
  findMdpsProductionOrderIds(solutionIds: number[]): Promise<Map<number, number>>;
  getVersions(solutionId: number): Promise<EngrVersionDTO[]>;
  setImagingSelection(solutionId: number, imagingId: number | null, activeSeriesId: string): Promise<void>;
  updateStatus(versionId: number, status: string): Promise<void>;
  updateEngineeringStatus(solutionId: number, status: string): Promise<void>;
  createVersion(data: { engineering_id: number; version: number; status: string }): Promise<{ id: number }>;
  createSolution(params: SolutionCreatePayload): Promise<EngrEngineeringDTO>;
  findSolutionsByCase(caseId: number): Promise<EngrEngineeringDTO[]>;
  updatePlanSetup(solutionId: number, params: SolutionPlanSetupUpdatePayload): Promise<void>;
  fetchSolutionsWithAppends(params: SolutionAppendsQueryParams): Promise<Record<string, unknown>[]>;
  getActiveSolutionCards(params: ActiveSolutionCardsQueryParams): Promise<Record<string, unknown>[]>;
  countCompletedTaskDispatches(params: CompletedTaskDispatchCountQueryParams): Promise<number>;
  getImagingParseState(solutionId: number): Promise<SolutionImagingParseStateDto | null>;
}

export const ISolutionRepository = createIdentifier<ISolutionRepository>('backend.solution.repository');
